export interface BankDetailsResponse {
  iban: string | null
  accountNumber: string | null
  routingNumber: string | null
  sortCode: string | null
  bankDetailsDocument: string | null
  isBankDetailsDocumentDeletable: boolean
  bankAccountPurpose?: BankAccountPurposeType
}

export interface IdentityDocument {
  name: string
  url: string
}

export interface IdentityDocumentsResponse {
  identityFulfilled: boolean
  documents: {
    PASSPORT?: IdentityDocument
    ID_CARD?: IdentityDocument
    ID_CARD_FRONT?: IdentityDocument
    ID_CARD_BACK?: IdentityDocument
    DRIVING_LICENCE_FRONT?: IdentityDocument
    DRIVING_LICENCE_BACK?: IdentityDocument
    BANK_STATEMENT?: IdentityDocument
  }
  isIdentityDocumentDeletable: boolean
}

export interface CustomerSsnResponse {
  socialSecurityNumber: string | null
}

export interface CustomerIdentityNumber {
  idType: string | null
  idNumber: string | null
}

export const BANK_ACCOUNT_PURPOSE = {
  CHECKING: 'CHECKING',
  SAVINGS: 'SAVINGS',
} as const

export const PAYMENT_INFOS_TYPES = {
  IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
  BANK_DETAILS: 'BANK_DETAILS',
  PERSONAL_IDENTIFICATION: 'PERSONAL_IDENTIFICATION',
  TAX_IDENTIFICATION_NUMBER: 'TAX_IDENTIFICATION_NUMBER',
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
} as const

export const PAYMENT_INFOS_OPTIONS = {
  ID_CARD: 'ID_CARD',
  PASSPORT: 'PASSPORT',
  DRIVING_LICENCE: 'DRIVING_LICENCE',
  ACH: 'ACH',
  BACS: 'BACS',
  SEPA: 'SEPA',
  SSN: 'SSN',
  SSN_NUMBER: 'SOCIAL_SECURITY_NUMBER',
  DRIVING_LICENCE_NUMBER: 'DRIVING_LICENCE_NUMBER',
} as const

export type BankAccountPurposeType = keyof typeof BANK_ACCOUNT_PURPOSE
export type PaymentInfosTypesType =
  (typeof PAYMENT_INFOS_TYPES)[keyof typeof PAYMENT_INFOS_TYPES]
export type PaymentInfosOptionsType =
  (typeof PAYMENT_INFOS_OPTIONS)[keyof typeof PAYMENT_INFOS_OPTIONS]

export interface PaymentInfo {
  type: PaymentInfosTypesType
  options: PaymentInfosOptionsType[]
  filled: boolean
}

export type PaymentInfoResponse = PaymentInfo[]
